import { KnowledgeBaseFacade } from '@agent/core/store/knowledge-base/knowledge-base.facade';
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';

import { AgentDesktopSearchComponent } from '@contact/upgrade';

import { ScriptingView, SurveyView } from './';
import { default as helpzoneName, Helpzone } from './helpzone.component.ajs';
import { ContactKnowledgeBaseOwiComponent } from './knowledge-base/knowledge-base-OWI.component';
import KnowledgeBase from './knowledge-base/knowledge-base.module.ajs';
import { OwiIframeComponent } from './knowledge-base/owi/iframe/owi-iframe.component';
import { KnowledgeBaseOwiApiService } from './knowledge-base/owi/services/knowledge-base-OWI-api.service';
import { KnowledgeBaseOwiService } from './knowledge-base/owi/services/knowledge-base-OWI.service';
import { HelpzoneSearchDeprecatedService } from './search/agent-desktop-helpzone-search-deprecated.service.ajs';

export default module('contact.agent.helpzone', [ScriptingView, SurveyView, KnowledgeBase])
  .service('helpzoneSearchDeprecatedService', HelpzoneSearchDeprecatedService)
  .directive('cngKnowledgeBaseOwi', downgradeComponent({ component: ContactKnowledgeBaseOwiComponent }) as angular.IDirectiveFactory)
  .directive('cngOwiIframe', downgradeComponent({ component: OwiIframeComponent }) as angular.IDirectiveFactory)
  .factory('knowledgeBaseOwiApiService', downgradeInjectable(KnowledgeBaseOwiApiService) as any)
  .factory('knowledgeBaseOwiService', downgradeInjectable(KnowledgeBaseOwiService) as any)
  .factory('knowledgeBaseFacade', downgradeInjectable(KnowledgeBaseFacade) as any)
  .directive('cngAgentDesktopHelpzoneSearch', downgradeComponent({ component: AgentDesktopSearchComponent }) as angular.IDirectiveFactory)
  .component(helpzoneName, new Helpzone()).name;
